export default __webpack_public_path__ + "static/media/TransportationSpaceships_02.16268894.png";